import { render, staticRenderFns } from "./TestHome.vue?vue&type=template&id=f483b2a6&scoped=true&"
import script from "./TestHome.vue?vue&type=script&lang=js&"
export * from "./TestHome.vue?vue&type=script&lang=js&"
import style0 from "./TestHome.vue?vue&type=style&index=0&id=f483b2a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f483b2a6",
  null
  
)

export default component.exports